var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"dblclick":_vm.handleDblClick,"click":_vm.handleClick}},[(_vm.reload)?_c('div',{style:(_vm.styleChartName),attrs:{"id":_vm.hid}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }